import { message } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { setMessageApi } from './toast';

const ToastProvider = ({ children }) => {
  const theme = useSelector((state) => state.settings.theme);
  const [messageApi, contextHolder] = message.useMessage({
    top: 24,
    duration: 3,
    maxCount: 3,
    rtl: false,
  });

  useEffect(() => {
    setMessageApi(messageApi);
  }, [messageApi]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <>
      {contextHolder}
      {children}
    </>
  );
};

export default ToastProvider;
